"use strict";

// Function to get the value of a specific cookie
function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

// Function to set gtag consent based on the CookieConsent cookie
function setGtagConsentFromCookie() {
  if (cookieConsent) {
    try {
      var consent = JSON.parse(decodeURIComponent(cookieConsent));
      typeof gtag === "function" && gtag("consent", "update", {
        ad_storage: consent.marketing ? "granted" : "denied",
        ad_user_data: consent.marketing ? "granted" : "denied",
        ad_personalization: consent.marketing ? "granted" : "denied",
        analytics_storage: consent.statistics ? "granted" : "denied"
      });
    } catch (e) {
      console.error("Error parsing CookieConsent cookie: ", e);
    }
  } else {
    // Set default consent to 'denied' if the cookie is not found
    typeof gtag === "function" && gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied"
    });
    window.showCookieBanner = true;
  }
}
function setBugsnagConsentFromCookie() {
  // if (cookieConsent) {
  //   try {
  //     let consent = JSON.parse(decodeURIComponent(cookieConsent));
  //     if (consent.statistics) {
  //       window.bugsnagClient = window.bugsnagClient || {};
  //       window.bugsnagClient.autoNotify = true;
  //     }
  //   } catch (e) {
  //     console.error("Error parsing CookieConsent cookie: ", e);
  //   }
  // }
}
var cookieConsent = getCookie("CookieConsent");
setGtagConsentFromCookie();
//# sourceMappingURL=cookieConsent.js.map